import React, { createContext, useCallback, useEffect, useState } from "react";
import {
  FetchBookiesService,
  FetchCountriesService,
  FetchFreeGamesService,
  FetchPlansService,
  FetchPremiumGamesService,
  FetchSlidersService,
  FetchUnitsService,
  FetchUserDataService,
  GetAdminDetailsService,
  GetAllUsersService,
  PostFCM,
} from "../models/ApiService";
import { ToastError } from "./component";
import { useNavigate } from "react-router";

// create context
const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuth, setisAuth] = useState(false);
  const [amount, setAmount] = React.useState("");
  const [user, setUser] = React.useState("");
  const [userData, setuserData] = useState({});
  const [SliderData, setSliderData] = useState([]);
  const [bookies, setBookies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [countriesData, setCountriesData] = useState([]);
  const [freeTips, setFreeTips] = React.useState([]);
  const [premiumTips, setPremiumTips] = React.useState([]);
  const [filteredCountries, setFilteredCountries] = useState();
  const [users, setUsers] = useState([]);
  const [units, SetUnits] = useState([]);
  const [plans, setPlans] = useState([]);
  const [adminDetails, setAdminDetails] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [loadingSliders, setLoadingSliders] = useState(false);
  const [loadingFreeTips, setLoadingFreeTips] = useState(false);
  const [loadingPremiumTips, setLoadingPremiumTips] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState(false);
  const [networkError, setNetworkError] = useState(
    `Error in fetching data..${"\n"}please check your internet connection`
  );

  const loadProfile = () => {
    try {
      const storedProfile = localStorage.getItem("user");
      if (storedProfile) {
        setUser(JSON.parse(storedProfile));
        setisAuth(true);
        fetchUserData(JSON.parse(storedProfile));
      }
    } catch (error) {}
  };

  useEffect(() => {
    setIsLoading(true);
    fetchUsers();
    loadProfile();
    fetchSliders();
    fetchBookies();
    fetchFreeTips();
    fetchCountries();
    fetchPremiumTips();
    fetchUnits();
    fetchPlans();
    fetchAdminDetails();
    setIsLoading(false);

    console.log();
  }, []);

  const login = (newProfile) => {
    try {
      setisAuth(true);
      setUser(newProfile);
      localStorage.setItem("user", JSON.stringify(newProfile));
    } catch (error) {
      return error;
    }
  };

  const logout = () => {
    try {
      setUser(null);
      localStorage.removeItem("user");
      setisAuth(false);
    } catch (error) {}
  };
  let updateUserData = (newData) => {
    setuserData({
      ...userData,
      ...newData,
    });
  };

  const loading = () => {
    setIsLoading(true);
  };

  const loaded = () => {
    setIsLoading(false);
  };

  function fetchSliders() {
    setLoadingSliders(true);
    try {
      FetchSlidersService().then((res) => {
        if (res.success == true) {
          let data = res.data;
          setSliderData([...data]);
          setLoadingSliders(false);
        } else {
          setLoadingSliders(false);
          setSliderData([]);
        }
      });
    } catch (error) {
      setError(error);
      setSliderData([]);
    }
  }

  function fetchUserData(user) {
    try {
      FetchUserDataService(user).then((fetchUserDataResponse) => {
        if (fetchUserDataResponse.success == true) {
          let data = fetchUserDataResponse.data;
          updateUserData({ ...data.userPublicData });
          // login({...data});
        } else {
          console.log(fetchUserDataResponse);
          alert(fetchUserDataResponse.message);
        }
      });
    } catch (error) {
      setError(error);
    }
  }

  function fetchBookies() {
    try {
      FetchBookiesService().then((res) => {
        if (res.success == true) {
          let data = res.data;

          setBookies([...data]);
        } else {
          setIsLoading(false);
          setBookies([]);
        }
      });
    } catch (error) {
      setError(error);
      alert(error);
      setBookies(null);
    }
  }

  function fetchUsers() {
    try {
      GetAllUsersService().then((res) => {
        if (res.success == true) {
          let data = res.data;
          setUsers([...data]);
        } else {
          setUsers([]);
        }
      });
    } catch (error) {
      setError(error);
      ToastError(error);
      setUsers([]);
    }
  }

  function fetchCountries() {
    try {
      FetchCountriesService().then((res) => {
        if (!res.error) {
          let data = res.data;
          setCountries([...data]);
          setFilteredCountries([...data]);
        } else {
          setIsLoading(false);
          setCountries([]);
        }
      });
    } catch (error) {
      setError(error);
      alert(error);
      setCountries(null);
    }
  }

  function fetchFreeTips() {
    try {
      FetchFreeGamesService().then((res) => {
        if (res.success == true) {
          let data = res.data;
          setIsLoading(false);
          // setIsLoading(false);
          return setFreeTips([...data]);
        } else {
          setIsLoading(false);
          setFreeTips([]);
          setError(true);
          setErrorMessage(res.message);
        }
      });
    } catch (error) {
      setError(error);
    }
  }

  function fetchPremiumTips() {
    try {
      FetchPremiumGamesService().then((res) => {
        if (res.success == true) {
          let data = res.data;

          return setPremiumTips([...data]);
        } else {
          setError(true);
        }
      });
    } catch (error) {
      setError(error);
    }
  }

  function fetchUnits() {
    try {
      FetchUnitsService().then((res) => {
        if (res.success == true) {
          let data = res.data;

          return SetUnits([...data]);
        } else {
          setError(true);
        }
      });
    } catch (error) {
      setError(error);
    }
  }

  function fetchPlans() {
    try {
      FetchPlansService().then((res) => {
        if (res.success == true) {
          let data = res.data;

          return setPlans([...data]);
        } else {
          setError(true);
        }
      });
    } catch (error) {
      setError(error);
    }
  }

  function fetchAdminDetails() {
    try {
      GetAdminDetailsService().then((res) => {
        if (res.success == true) {
          let data = res.data;

          return setAdminDetails(data);
        } else {
          setError(true);
        }
      });
    } catch (error) {
      setError(error);
    }
  }

  const filterBookies = (filter) => {
    setBookies(filter);
  };

  const filterCountries = (filter) => {
    setCountries(filter);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuth,
        login,
        logout,
        updateUserData,
        userData,
        amount,
        setAmount,
        user,
        loading,
        isLoading,
        loaded,
        errorMessage,
        setErrorMessage,
        networkError,
        fetchUserData,
        fetchSliders,
        error,
        SliderData,
        fetchBookies,
        bookies,
        filterBookies,
        fetchFreeTips,
        freeTips,
        countries,
        setCountriesData,
        countriesData,
        filterCountries,
        fetchCountries,
        fetchPremiumTips,
        premiumTips,
        loadingSliders,
        setCountries,
        users,
        fetchUsers,
        units,
        plans,
        adminDetails,
        menuOpen,
        setMenuOpen,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
